import { FileTypeEnum } from "@/constants/enums/fileType.enum";
import { ExpeditionDocumentFileBoDto, ExpeditionDocumentFileDto } from "@/types/api/api-types";
import { useMemo } from "react";

type DocumentFile = ExpeditionDocumentFileDto | ExpeditionDocumentFileBoDto;

export type DocumentFormatVariant = {
  file: DocumentFile;
  label: string;
};

const EXCEL_SUFFIX = "_EXCEL";

export const toExcelFileType = (fileType: FileTypeEnum): FileTypeEnum =>
  `${fileType}${EXCEL_SUFFIX}` as FileTypeEnum;

export const useDocumentFormats = (documents: DocumentFile[], primaryFileType: FileTypeEnum) => {
  const excelFileType = toExcelFileType(primaryFileType);

  return useMemo(() => {
    const relevantTypes = [primaryFileType, excelFileType];
    const matchingFiles = documents.filter((d) => relevantTypes.includes(d.type as FileTypeEnum));

    const primaryFile = matchingFiles.find((f) => f.type === primaryFileType);
    const excelFile = matchingFiles.find((f) => f.type === excelFileType);
    const displayFile = primaryFile ?? excelFile;

    const alternateFormats: DocumentFormatVariant[] | undefined =
      primaryFile && excelFile
        ? [
            { file: primaryFile, label: "PDF" },
            { file: excelFile, label: "Excel" },
          ]
        : undefined;

    return { displayFile, alternateFormats };
  }, [documents, primaryFileType, excelFileType]);
};
